export async function getConfig() {
  const res = await fetch("/data/config.json");
  return res.json();
}
